/**
 * @owner @Appboy/messaging-experience
 */

import { cohortRemoteLookupValidators } from "@schemas/remoteLookup/cohortRemoteLookupSchema";
import type { CohortRemoteLookupId, CohortRemoteLookupItem, CohortRemoteLookupFilters } from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const cohortProvider: RemoteLookupProvider<
  CohortRemoteLookupId,
  CohortRemoteLookupItem,
  CohortRemoteLookupFilters
> = {
  mapItemToId: (item) => `${item.partner_token}:${item.cohort_id}`,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: cohortRemoteLookupValidators,
};
